import { render, staticRenderFns } from "./VoirVin.vue?vue&type=template&id=e8c2aecc&"
import script from "./VoirVin.vue?vue&type=script&lang=js&"
export * from "./VoirVin.vue?vue&type=script&lang=js&"
import style0 from "./VoirVin.vue?vue&type=style&index=0&id=e8c2aecc&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8c2aecc')) {
      api.createRecord('e8c2aecc', component.options)
    } else {
      api.reload('e8c2aecc', component.options)
    }
    module.hot.accept("./VoirVin.vue?vue&type=template&id=e8c2aecc&", function () {
      api.rerender('e8c2aecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/VoirVin.vue"
export default component.exports